export default "__VITE_ASSET__Ho3FlRav__"